import { configureStore } from '@reduxjs/toolkit'
import loadingReducer from '../features/loading/loadingSlice'
import nutiteeReducer from '../features/nutitee/nutiteeSlice'

export default configureStore({
    reducer: {
        loading: loadingReducer,
        nutitee: nutiteeReducer,
    },
})